import { AuthService } from '../services/auth/auth.service';
import { HttpRequest } from '../services/httpRequest';


export const validateTokenSession = async(token, doc) => {
    try {
        const {isValid} = await HttpRequest.validateTokenSession({token, doc});
        return isValid;
    } catch (error) {
        return false;
    }
    
}


export const validateTokenSessionVisitor = async(token, doc) => {
    try {
        const {isValid} = await HttpRequest.validateTokenSessionVisitor({token, doc});
        return isValid;
    } catch (error) {
        return false;
    }
    
}

export const validateSessionAndJwtToken = async() => {
    try {
        const {message} = await AuthService.validateSessionAndJwtToken();
        let {isValid} = message;
        return isValid;
    } catch (error) {
        return false;
    }
    
}
